<template>
	<div class="row">
		<div class="col-xl-12 lists__user-boxes-box-wrapper" v-for="item in wishRender" :key="item.ID">
			<a class="lists__user-boxes-box-link" :href="kadraGlobal.Url+'/single-my-lists?id='+item.ID">
				<div class="lists__user-boxes-box">
					<div class="lists__user-boxes-box-left">
						<div class="lists__user-boxes-box-left-top">
							<span class="lists__user-boxes-box-left-top-title" v-html="item.title"></span>
						</div>
						<div class="lists__user-boxes-box-left-bottom">
							<span class="lists__user-boxes-box-left-bottom-num-items" v-if="item.count === 1" :class="{'lists__user-boxes-box-left-bottom-num-items--has-item': item.count > 0, '': item.count === 0}" v-html="item.count+' item'"></span>
							<span class="lists__user-boxes-box-left-bottom-num-items" v-else :class="{'lists__user-boxes-box-left-bottom-num-items--has-item': item.count > 0, '': item.count === 0}" v-html="item.count+' items'"></span>
							<span class="lists__user-boxes-box-left-bottom-last-edited" v-html="'Created: '+ checkDate(item.date)"></span>
						</div>
					</div>
					<div class="lists__user-boxes-box-right">
						<span class="lists__user-boxes-box-right-link">View list</span>
					</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
export default {
	props: ['wishRender', 'kadraGlobal'],
	methods: {
		checkDate(date) {
			if (date !== undefined) {
				const spl = date.split(' ');
				const dateSpl = spl[0].split('-');
				return dateSpl[1] + '/' + dateSpl[2] + '/' + dateSpl[0];
			}
		},
	}
};
</script>

<style lang="scss" scoped></style>
